import { blobResponseHandler, downloadBlob } from '@/shared/helpers/api';
import { buildGetCrossdockLookupEndpoint, buildGetStockInfoEndpoint, buildGetStockLocationsEndpoint, buildRelocateStockItemEndpoint, stocksSharedTagTypes, } from '@/shared/modules/stocks/business';
import { t } from '@/core/localization';
import { showApiErrorSnackbar } from '@/shared/helpers/thunk';
import { baseApi } from '@/warehouse/baseApi';
import { getStockLocationId } from '@/warehouse/helpers';
// TODO: rename later, when legacy stockApi is fully removed. and delete redundant comments
const stocksApi = baseApi.enhanceEndpoints({ addTagTypes: [...stocksSharedTagTypes] }).injectEndpoints({
    endpoints: (builder) => ({
        // getStockList: buildGetStockListEndpoint(builder),
        getStockInfo: buildGetStockInfoEndpoint(builder),
        // getStockBalance: buildGetStockBalanceEndpoint(builder),
        // exportStockToExcel: buildExportStockToExcelEndpoint(builder),
        getCrossdockLookup: buildGetCrossdockLookupEndpoint(builder),
        getStockLocations: buildGetStockLocationsEndpoint(builder),
        relocateStockItem: buildRelocateStockItemEndpoint(builder),
        getStockList: builder.query({
            query: () => `stock/${getStockLocationId()}/stocks`,
            providesTags: ['StockList'],
            onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
                try {
                    await queryFulfilled;
                }
                catch (error) {
                    dispatch(showApiErrorSnackbar({ header: t('get.stock.list.request.failed'), error }));
                }
            },
        }),
        getStockRemains: builder.query({
            query: ({ stockId, groupByCell }) => {
                return {
                    method: 'GET',
                    url: `stock/${getStockLocationId()}/${stockId}/remains`,
                    params: { groupByCell },
                };
            },
            // transformResponse: (response: StockItem[] | StockCell[], meta, { grouped }) =>
            //   grouped ? (response as StockCell[]) : ([{ cell: undefined, stockItems: response }] as StockCell[]),
            providesTags: ['Stock'],
        }),
        exportStockRemainsToExcel: builder.mutation({
            queryFn: async ({ stockId }, api, extraOptions, baseQuery) => downloadBlob({
                queryResult: await baseQuery({
                    method: 'GET',
                    cache: 'no-cache',
                    url: `stock/${getStockLocationId()}/${stockId}/remains/xlsx`,
                    responseHandler: blobResponseHandler,
                }),
                fileName: `stockRemains_${stockId.toString().padStart(5, '0')}.xlsx`,
            }),
        }),
    }),
    // overrideExisting: 'throw', // TODO: later RETURN BACK
    overrideExisting: true, // Here we override exactly the same old backend endpoint from shared api. Return back 'throw' when we have only one!
});
export { stocksApi };
// TODO: check later if all are used
export const { useGetStockInfoQuery, useGetStockListQuery, useGetStockRemainsQuery, useExportStockRemainsToExcelMutation, useGetStockLocationsQuery, useGetCrossdockLookupQuery, } = stocksApi;
